import { HeaderBarRight } from "slot-definitions"
import { InternalIndicator } from "lib/@components/save-indicator/internal-indicator"

// Re-export so existing imports like `import { ToBeSaved } from "...save-indicator"` keep working
export { ToBeSaved } from "lib/@components/save-indicator/to-be-saved"

export function SaveIndicator({ id, slot = HeaderBarRight }) {
    const Slot = slot
    return (
        <Slot.Plug>
            <InternalIndicator key={id} priority={-200} id={id} />
        </Slot.Plug>
    )
}
